import { useTranslation } from 'next-i18next';
import { FilterType, freeFormHubFilterKeys } from '../../types';
import { FilterWrapper } from '../filterWrapper/filterWrapper';
import { useFreeFormHubInputValidator } from '../../hooks/inputValidator';
import { useFreeFormHubFilterState } from '../../hooks/useUrlFilterState';
import { v4 } from 'uuid';

export const EnvironmentSection = () => {
  const { t } = useTranslation(['category/productFilter', 'common']);

  const checkboxValidator = useFreeFormHubInputValidator(FilterType.CHECKBOX);
  const [dirtValue, setDirtValue] = useFreeFormHubFilterState<FilterType.CHECKBOX>(
    freeFormHubFilterKeys.DIRT_AND_DUST,
    checkboxValidator
  );
  const [waterAbsorbtionValue, setWaterAbsorbtionValue] = useFreeFormHubFilterState<FilterType.CHECKBOX>(
    freeFormHubFilterKeys.LOW_WATER_ABSORBTION,
    checkboxValidator
  );
  const [chemicalsValue, setChemicalsValue] = useFreeFormHubFilterState<FilterType.CHECKBOX>(
    freeFormHubFilterKeys.CHEMICALS,
    checkboxValidator
  );
  const [splashWaterValue, setSplashWaterValue] = useFreeFormHubFilterState<FilterType.CHECKBOX>(
    freeFormHubFilterKeys.UNDERWATER_SPLASHWATER,
    checkboxValidator
  );

  const SectionConfig = [
    {
      type: FilterType.CHECKBOX,
      props: {
        disabled: false,
        key: freeFormHubFilterKeys.DIRT_AND_DUST,
        id: freeFormHubFilterKeys.DIRT_AND_DUST,
        label: t(`FILTERS.LABELS.DIRT_AND_DUST`, { ns: 'free-form-hub/freeFormHub' }),
        value: dirtValue ?? false,
        onChange: newValue => {
          setDirtValue(newValue === true ? true : undefined);
        },
      },
    },
    {
      type: FilterType.CHECKBOX,
      props: {
        disabled: false,
        key: freeFormHubFilterKeys.LOW_WATER_ABSORBTION,
        id: freeFormHubFilterKeys.LOW_WATER_ABSORBTION,
        label: t(`FILTERS.LABELS.LOW_WATER_ABSORBTION`, { ns: 'free-form-hub/freeFormHub' }),
        value: waterAbsorbtionValue ?? false,
        onChange: newValue => {
          setWaterAbsorbtionValue(newValue === true ? true : undefined);
        },
      },
    },
    {
      type: FilterType.CHECKBOX,
      props: {
        disabled: false,
        key: freeFormHubFilterKeys.CHEMICALS,
        id: freeFormHubFilterKeys.CHEMICALS,
        label: t(`FILTERS.LABELS.CHEMICALS`, { ns: 'free-form-hub/freeFormHub' }),
        value: chemicalsValue ?? false,
        onChange: newValue => {
          setChemicalsValue(newValue === true ? true : undefined);
        },
      },
    },
    {
      type: FilterType.CHECKBOX,
      props: {
        disabled: false,
        key: freeFormHubFilterKeys.UNDERWATER_SPLASHWATER,
        id: freeFormHubFilterKeys.UNDERWATER_SPLASHWATER,
        label: t(`FILTERS.LABELS.UNDERWATER_SPLASHWATER`, { ns: 'free-form-hub/freeFormHub' }),
        value: splashWaterValue ?? false,
        onChange: newValue => {
          setSplashWaterValue(newValue === true ? true : undefined);
        },
      },
    },
  ];

  return (
    <>
      {SectionConfig.map(filter => {
        const uuId = v4();

        return (
          <div className="mt-8" key={uuId}>
            <FilterWrapper type={filter.type} props={filter.props} />
          </div>
        );
      })}
    </>
  );
};
